import { t } from 'Locale';
import { Device } from 'DeviceUtils';
import { addLeadingZero } from 'Utils/index';

const months = [
    'MONTH.JANUARY',
    'MONTH.FEBRUARY',
    'MONTH.MARCH',
    'MONTH.APRIL',
    'MONTH.MAY',
    'MONTH.JUNE',
    'MONTH.JULY',
    'MONTH.AUGUST',
    'MONTH.SEPTEMBER',
    'MONTH.OCTOBER',
    'MONTH.NOVEMBER',
    'MONTH.DECEMBER'
];

const days = [
    'DATE.SUNDAY',
    'DATE.MONDAY',
    'DATE.TUESDAY',
    'DATE.WEDNESDAY',
    'DATE.THURSDAY',
    'DATE.FRIDAY',
    'DATE.SATURDAY'
];

const dateLocales = {
    sk: 'sk-SK',
    cs: 'cs-CZ',
    cz: 'cs-CZ'
};

export function formatDay(dayIndex, maxLength) {
    let dayString = t(days[dayIndex]);
    if (typeof maxLength === 'number') {
        dayString = dayString.substr(0, maxLength);
    }
    return dayString;
}

export function formatMonth(monthIndex, maxLength) {
    let monthString = t(months[monthIndex]);
    if (typeof maxLength === 'number') {
        monthString = monthString.substr(0, maxLength);
    }
    return monthString;
}

const toLocaleDateStringAndroid = (time) => {
    const date = new Date(time);
    // eslint-disable-next-line max-len
    return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}, ${addLeadingZero(
        date.getHours()
    )}:${addLeadingZero(date.getMinutes())}`;
};

const defaultLocaleOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};

export const toLocaleDateString = (time, locale = 'default', options = defaultLocaleOptions) =>
    Device.isAndroid
        ? toLocaleDateStringAndroid(time)
        : new Date(time).toLocaleDateString(dateLocales[locale] || locale, options);

export const getHoursAndMinutes = (time) =>
    `${addLeadingZero(new Date(time).getHours())}:${addLeadingZero(new Date(time).getMinutes())}`;

export const getDayAndMonth = (time) =>
    `${addLeadingZero(new Date(time).getDate())}.${addLeadingZero(new Date(time).getMonth() + 1)}.`;

export const getDayDotMonthDotYear = (date) => {
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, '0')}.${Number(d.getMonth() + 1)
        .toString()
        .padStart(2, '0')}.${d.getFullYear()}`;
};
